import {
  type PostUpdateUserGroupMembershipDto,
  ResponseMetadataMessageDtoLevel,
  UpdateUserGroupMembershipResponseDtoStatus,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { assert, UnreachableCaseError } from 'ts-essentials';
import { call, put, takeLeading } from 'typed-redux-saga';
import { PrayerStreamApiService } from '../../../services/prayer-stream';
import { getAccessTokenSaga } from '../../auth/accessToken.saga';
import { streamSlice } from '../../stream/stream.slice';
import { getContainer } from '../../utils.saga';
import { updateUserGroupMembershipSlice } from './update-user-group-membership.slice';

export function* updateUserGroupMembershipSaga(
  params: PostUpdateUserGroupMembershipDto,
): Generator {
  const container = yield* getContainer();
  const { prayerStreamApi } = container.get(PrayerStreamApiService);

  yield* put(
    updateUserGroupMembershipSlice.actions.updateUserGroupMembershipStarted(),
  );

  const accessToken = yield* getAccessTokenSaga();
  assert(accessToken);

  const { data } = yield* call(async () => {
    try {
      return await prayerStreamApi.prayerStreamControllerUpdateUserGroupMembershipV1(
        {
          postUpdateUserGroupMembershipDto: params,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
    } catch (error) {
      return {
        data: {
          metadata: {
            messages: [
              {
                level: ResponseMetadataMessageDtoLevel.ERROR,
                text: `PrayerStream level error: ${(error as Error).message}`,
              },
            ],
            requestId: '001',
          },
          status: UpdateUserGroupMembershipResponseDtoStatus.OTHER,
        },
      };
    }
  });

  switch (data.status) {
    case UpdateUserGroupMembershipResponseDtoStatus.OTHER:
      yield* put(
        updateUserGroupMembershipSlice.actions.updateUserGroupMembershipFailed(
          data.status,
        ),
      );
      break;
    case UpdateUserGroupMembershipResponseDtoStatus.SUCCESS:
      yield* put(
        updateUserGroupMembershipSlice.actions.updateUserGroupMembershipSucceeded(
          data.status,
        ),
      );
      yield* put(streamSlice.actions.setCommunityGroupList(null));
      break;
    /* v8 ignore next 2 */
    default:
      throw new UnreachableCaseError(data);
  }
}

export function* watchUserGroupMembershipSaga(): Generator {
  yield* takeLeading(
    updateUserGroupMembershipSlice.actions.updateUserGroupMembershipRequested,
    function* lambda(action) {
      yield* call(updateUserGroupMembershipSaga, action.payload);
    },
  );
}
